import Quill from 'quill';
import 'quill-mention';
import 'quill/dist/quill.snow.css';

export default function (context, inject) {
  inject('quill', Quill);
}
